'use strict';

class Otp {
  constructor($window, originatorService, $interval) {
    this.$window = $window;
    this.originatorService = originatorService;
    this.$interval = $interval;
  }

  $onInit() {
    this.otp = '';
    this.mobile = '';
    this.otpGenerated = false;
    this.secondsLeft = 0;
  }

  confirm() {
    let params = {
      otp: this.otp
    };

    return this.originatorService.confirmOtp(params)
      .then((resp) => {
        this.$window.location.href = '/side/#/beslutning-kreves';
      });
  }

  generateOtp() {
    let params = {
      mobile: this.mobile
    };

    this.originatorService.generateOtp(params)
      .then((resp) => {
        this.otpGenerated = true;
        this.countDown();
      });
  }

  countDown() {
    this.secondsLeft = 60;
    let check = this.$interval(() => {
      if (this.secondsLeft > 0) {
        this.secondsLeft--;
      }
    }, 1000);
  }
}


Otp.$inject = ['$window', 'originatorService', '$interval'];

const otp = {
  controller: Otp,
  template: `
    <h2>Bekreftelse kreves</h2>
          <div class="row">
            <div class="large-6 columns">
             <label for="phoneNumber">Mobilnummer</label>
              <input type="tel" id="phoneNumber" name="phoneNumber" ng-model="$ctrl.mobile" international-mobile-number-validator>
              <button class="button secondary" ng-show="$ctrl.secondsLeft === 0" ng-click='$ctrl.generateOtp()'>Send SMS-kode</button>
              <div ng-show="$ctrl.secondsLeft > 0">Ny kode kan genereres om {{$ctrl.secondsLeft}} sekunder</div>
            </div>
          </div>
          <div class="row" ng-show="$ctrl.otpGenerated">
            <div class="large-6 columns">
             <label for="otp">Kode</label>
              <input type="tel" id="otp" name="otp" ng-model="$ctrl.otp" maxlength="6">
              <button class="button secondary" ng-click="$ctrl.confirm()">Bekreft</button>
            </div>
          </div>
  `
};

angular
  .module('SendRegning')
  .component('otp', otp)
  .config(($routeProvider) => {
    $routeProvider
      .when('/bekrefte', {
        title: 'Otp requited',
        template: '<otp/>',
        noSidebar: true,
        noNav: true,
        secure: true
      });
  });
